import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class ProjectSuggestionDataService {
  constructor(private readonly http: HttpClient) { }

  findByName(query: string): Observable<any[]> {
    return this.http.get<any[]>('/api/projectnamesuggestions', {
      params: { limit: 11, q: JSON.stringify({ projectName: query }) } as any
    });
  }

  findById(query: string): Observable<any[]> {
    return this.http.get<any[]>('/api/projectIdSuggestions', {
      params: { limit: 11, q: JSON.stringify({ projectId: query }) } as any
    });
  }
}
